import React, { useCallback } from "react";

import { Navigation } from "../types/navigation";
import { NavigationFooter } from "../valuation-manager.styles";
import { useValuationManagerContext } from "../ValuationManagerContext";

type Props = {
  setPageName: (pageName: Navigation) => void;
  disabled?: boolean;
};

const getPreviousPage = (currentPage: Navigation): Navigation | undefined => {
  const currentIndex = pageOrder.indexOf(currentPage);
  return currentIndex > 0 ? pageOrder[currentIndex - 1] : undefined;
};

const getNextPage = (currentPage: Navigation): Navigation | undefined => {
  const currentIndex = pageOrder.indexOf(currentPage);
  return currentIndex >= 0 && currentIndex < pageOrder.length - 1
    ? pageOrder[currentIndex + 1]
    : undefined;
};

const pageOrder = [
  Navigation.Qualifications,
  Navigation.Modifications,
  Navigation.ServiceHistory,
  Navigation.Conditions,
  Navigation.MechanicalAndElectrical,
  Navigation.Summary,
];

export const NavigationButton = ({ setPageName, disabled = false }: Props) => {
  const { pageName } = useValuationManagerContext();
  const previousPage = pageName && getPreviousPage(pageName);
  const NextPage = pageName && getNextPage(pageName);

  const handleClickNext = useCallback(() => {
    const formElement = document.getElementById("vmu-form") as HTMLFormElement;
    if (!formElement?.checkValidity()) {
      formElement?.reportValidity();
      return;
    }

    NextPage && setPageName(NextPage);
  }, [setPageName, NextPage]);

  return (
    <NavigationFooter className="row">
      {(previousPage && (
        <div className="col-sm-6 col-md-6 col-lg-6">
          <button
            onClick={() => setPageName(previousPage)}
            type="button"
            className="btn btn-default"
            data-testid="back-button"
          >
            Back
          </button>
        </div>
      )) || <div className="col-sm-6 col-md-6 col-lg-6" />}
      {NextPage && (
        <div className="col-sm-6 col-md-6 col-lg-6 text-right">
          <button
            onClick={handleClickNext}
            type="button"
            disabled={disabled}
            className="btn btn-success"
            data-testid="next-button"
          >
            Next
          </button>
        </div>
      )}
    </NavigationFooter>
  );
};
